import React, { useState, useEffect } from 'react';

const QuizCard = ({ question, onAnswer, timer }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [answered, setAnswered] = useState(false);
  
  // Effet pour réinitialiser l'état lorsque la question change
  useEffect(() => {
    setSelectedOption(null);
    setAnswered(false);
  }, [question]);
  
  // Gestionnaire de clic sur une option
  const handleOptionClick = (optionIndex) => {
    if (answered) return; // Empêcher de changer de réponse
    
    setSelectedOption(optionIndex);
    setAnswered(true);
    
    // Attendre un court délai pour que l'utilisateur puisse voir sa sélection
    setTimeout(() => {
      onAnswer(optionIndex);
    }, 500);
  };
  
  if (!question) return null;
  
  return (
    <div className="quiz-card">
      <h3>{question.question}</h3>
      <div className="quiz-options">
        {question.options.map((option, index) => (
          <div 
            key={index} 
            className={`quiz-option ${selectedOption === index ? 'selected' : ''}`}
            onClick={() => handleOptionClick(index)}
          >
            <div className="option-letter">
              {['A', 'B', 'C', 'D'][index]}
            </div>
            <div className="option-text">{option}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuizCard;